export default "__VITE_ASSET__BWxreJSM__"